export interface OptionsStatus {
  status: string;
  label: string;
}

export interface OptionsFlag {
  flag: string;
  label: string;
}

export interface OptionsHarmon {
  value: string;
  label: string;
}

export interface OptionsCenter {
  value: string;
  label: string;
}

export interface OptionsEngenheiro {
  value: string;
  label: string;
}

type Option =
  | OptionsStatus
  | OptionsFlag
  | OptionsHarmon
  | OptionsCenter
  | OptionsEngenheiro;

export const optionsStatus = [
  { status: "NOVO", label: "Novo" },
  { status: "EM_CLASSIFICACAO", label: "Em Classificação" },
  {
    status: "PENDENTE_VALIDACAO_FISCAL",
    label: "Pendente de Validação Fiscal",
  },
  { status: "EM_ANALISE", label: "Em Análise" },
  { status: "FINALIZADO", label: "Processo Finalizado" },
  { status: "RECLASSIFICAR", label: "Reclassificar" },
  { status: "RECLASSIFICADO", label: "Reclassificado" },
  { status: "SUSPENSO", label: "Suspenso" },
  { status: "ENTREGUE_SAP", label: "Entregue SAP" },
  { status: "PENDENTE_GRUPO", label: "Pendente de Grupo" },
];

export const optionsFlag = [
  { flag: "RFB 1", label: "RFB 1" },
  { flag: "RFB 2", label: "RFB 2" },
  { flag: "RFB 3", label: "RFB 3" },
  { flag: "RFB 4", label: "RFB 4" },
  { flag: "RFB 5", label: "RFB 5" },
  { flag: "Auditoria 1", label: "Auditoria 1" },
  { flag: "Auditoria 2", label: "Auditoria 2" },
  { flag: "Auditoria 3", label: "Auditoria 3" },
  { flag: "Auditoria 4", label: "Auditoria 4" },
  { flag: "Auditoria 5", label: "Auditoria 5" },
  { flag: "Auditoria 6", label: "Auditoria 6" },
  { flag: "Auditoria 7", label: "Auditoria 7" },
  { flag: "Auditoria 8", label: "Auditoria 8" },
  { flag: "Auditoria 9", label: "Auditoria 9" },
  { flag: "Auditoria X", label: "Auditoria X" },
  { flag: "Auditoria inconclusiva", label: "Auditoria inconclusiva" },
];

export const optionsHamonizado = [
  { value: "true", label: "Sim" },
  { value: "false", label: "Não" },
];

export const getRestrictedOptionsStatus = (
  isTax: boolean,
  isEngineer: boolean
): OptionsStatus[] => {

  const restrictionTax = new Set([""]);
  const restrictionEngenheiro = new Set(["ENTREGUE_SAP", "PENDENTE_GRUPO"]);

  return optionsStatus
    .filter((option) => {
      if (option.status === "PENDENTE_GRUPO") {
        return isTax;
      }

      if (isTax) {
        return !restrictionTax.has(option.status);
      }

      if (isEngineer) {
        return !restrictionEngenheiro.has(option.status);
      }

      return true;
    })
    .map((option) => {
      if (isEngineer && option.status === "ENTREGUE_SAP") {
        return { ...option, label: "Entregue SAP" };
      }
      return option;
    });
};

export const handleAutocompleteChange = <T extends Option>(
  setState: ((options: T[]) => void) | undefined,
  localStorageKey: string
) => {
  return (_: React.SyntheticEvent, newValue: T[]) => {
    if (setState) {
      setState(newValue);
    }
    localStorage.setItem(localStorageKey, JSON.stringify(newValue));
  };
};
